import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import Typography from '@mui/material/Typography';
import WithLoadingHandler from 'hoc/withLoadingHandler/withLoadingHandler';

export const ProxyDialog = ({
	open = false,
	options = [],
	onChange = () => {},
	onClose = () => {},
	value = null,
}) => {
	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle>Validation Proxy</DialogTitle>
			<DialogContent>
				<DialogContentText id='label--direct-reports--dialog'>
					Serve as a proxy and validate on behalf of a reporting
					supervisor.
				</DialogContentText>
				<WithLoadingHandler
					isLoading={options === null}
					showChildren={options !== null}
				>
					<Box sx={{ marginTop: '8px' }}>
						{options !== null && options.length > 0 ? (
							<Grid
								sx={{
									flexGrow: 1,
									alignItems: 'center',
									justifyContent: 'center',
								}}
								container
							>
								<Grid xs={10}>
									<FormControl fullWidth>
										<InputLabel id='select--proxy__label'>
											Reporting Supervisor
										</InputLabel>
										<Select
											labelId='select--proxy__label'
											id='select--proxy'
											label='Reporting Supervisor'
											onChange={onChange}
											value={value}
										>
											{options &&
												options.map(proxy => (
													<MenuItem
														key={proxy.ID}
														value={proxy}
													>
														{proxy.Name}
													</MenuItem>
												))}
										</Select>
									</FormControl>
								</Grid>
								{value && (
									<Grid xs={1} sx={{ marginLeft: '8px' }}>
										<IconButton
											onClick={() => onChange(null)}
										>
											<ClearIcon />
										</IconButton>
									</Grid>
								)}
							</Grid>
						) : (
							<Typography
								sx={{
									color: 'warning.main',
									textAlign: 'center',
								}}
								variant='body2'
							>
								You have no reporting supervisors and cannot
								serve as a proxy.
							</Typography>
						)}
					</Box>
				</WithLoadingHandler>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Close</Button>
			</DialogActions>
		</Dialog>
	);
};
